export var AuviousErrors;
(function (AuviousErrors) {
    AuviousErrors[AuviousErrors["OFFLINE"] = 0] = "OFFLINE";
    AuviousErrors[AuviousErrors["UNREACHABLE"] = 1] = "UNREACHABLE";
    AuviousErrors[AuviousErrors["UNKNOWN"] = 2] = "UNKNOWN";
    AuviousErrors[AuviousErrors["ECONNABORTED"] = 3] = "ECONNABORTED";
    AuviousErrors[AuviousErrors["ETIMEDOUT"] = 4] = "ETIMEDOUT";
})(AuviousErrors || (AuviousErrors = {}));
const defaultError = {
    code: AuviousErrors.UNKNOWN,
    status: AuviousErrors.UNKNOWN,
    message: AuviousErrors.UNKNOWN,
    error_description: AuviousErrors.UNKNOWN,
    error_message: AuviousErrors.UNKNOWN,
};
export class AuviousError extends Error {
    get error() {
        return true;
    }
    constructor(_raw = defaultError) {
        super();
        this._raw = _raw;
        this.code = _raw.code;
        this.status = _raw.status;
        this.message = _raw.message;
    }
    toJSON() {
        return this._raw;
    }
    toString() {
        return JSON.stringify(this._raw);
    }
    static create(message, code = AuviousErrors.UNKNOWN, status = "UNKNOWN") {
        return new AuviousError({ message, code, status });
    }
}
